<template>
  <transition name="message-fade">
    <div v-if="visible" :class="['message-box', typeClass]" :style="positionStyle">
      <div class="message-content">
        <span class="message-text">{{ message }}</span>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  name: 'CustomMessage',
  data() {
    return {
      visible: false,
      message: '',
      type: 'success', // success, warning, error, info
      duration: 2000,
      position: 'center',
      timer: null
    }
  },
  computed: {
    typeClass() {
      return `message-${this.type}`;
    },
    positionStyle() {
      const positions = {
        center: {
          top: '30%',
          left: '50%',
          transform: 'translate(-50%, -50%)'
        },
        'top-center': {
          top: '20%',
          left: '50%',
          transform: 'translateX(-50%)'
        }
      };
      return positions[this.position] || positions.center;
    }
  },
  methods: {
    show(options) {
      this.message = options.message || '';
      this.type = options.type || 'info';
      this.duration = options.duration || 2000;
      this.position = options.position || 'center';
      this.visible = true;
      
      if (this.timer) {
        clearTimeout(this.timer);
      }
      
      this.timer = setTimeout(() => {
        this.close();
      }, this.duration);
    },
    close() {
      this.visible = false;
      if (this.timer) {
        clearTimeout(this.timer);
        this.timer = null;
      }
      if (this.onClose) {
        this.onClose();
      }
    }
  }
}
</script>

<style lang="less" scoped>
.message-box {
  position: fixed;
  z-index: 9999;
  min-width: 300px;
  max-width: 500px;
  padding: 16px 24px;
  border-radius: 8px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15);
  display: flex;
  align-items: center;
  justify-content: center;
  backdrop-filter: blur(10px);
  
  .message-content {
    display: flex;
    align-items: center;
    
    .message-text {
      font-size: 14px;
      line-height: 1.5;
      text-align: center;
      font-weight: 500;
    }
  }
  
  &.message-success {
    background: #85CF67;
    color: #FFFFFF;
    box-shadow: 0 2px 8px rgba(133, 207, 103, 0.5);
  }
  
  &.message-error {
    background: #F78989;
    color: #FFFFFF;
    box-shadow: 0 2px 8px rgba(247, 137, 137, 0.5);
  }
  
  &.message-warning {
    background: #F8C96B;
    color: #FFFFFF;
    box-shadow: 0 2px 8px rgba(248, 201, 107, 0.5);
  }
  
  &.message-info {
    background: #6BA9F8;
    color: #FFFFFF;
    box-shadow: 0 2px 8px rgba(107, 169, 248, 0.5);
  }
}

.message-fade-enter-active,
.message-fade-leave-active {
  transition: opacity 0.3s ease, transform 0.3s ease;
}

.message-fade-enter,
.message-fade-leave-to {
  opacity: 0;
  transform: translate(-50%, -60%);
}
</style>
